import { render, staticRenderFns } from "./CompetitionPage.vue?vue&type=template&id=255dbb8a"
import script from "./CompetitionPage.vue?vue&type=script&lang=js"
export * from "./CompetitionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports